/* eslint-ignore */
// @ts-nocheck
import { Field as FormikField, Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Form as BootstrapForm } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import TextArea from '~/components/layout/form/textArea';
import TextField from '~/components/layout/form/textField';
import theme from '~/styles/theme';
import phoneMask from '~/utils/phoneMask';
import {
  ButtonContainer,
  Buttons,
  ButtonStyled as Button,
  ButtonText,
  ButtonWidth,
  CloseIcon,
  Container,
  EditIcon,
  Header,
  Left,
  PhoneIcon,
  Question,
  QuestionClose,
  Title,
  UserIcon,
} from './styles';

class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      equipment: 'teste',
    };
  }

  createAssistance = (values) => {
    const { props } = this;
    const detail = `Nome: ${values.name} - Telefone: ${values.phone} - Justificativa: ${values.justification}`;
    const data = {
      values,
      props,
    };
    this.props.hideModal();
    return this.props.request(data);
  };

  hideModal = () => {
    return this.props.hideModal();
  };

  handleResponse = (response) => {
    if (response === 'voltar') {
      return this.props.handleClick('010102');
    }
  };

  handleRequestSchema = () => {
    let RequestSchema;
    if (this.props.hideJustification) {
      RequestSchema = Yup.object().shape({
        name: Yup.string().trim().required('Informe seu nome'),
        phone: Yup.string().required('Campo obrigatório'),
      });
    } else {
      RequestSchema = Yup.object().shape({
        name: Yup.string().trim().required('Informe seu nome'),
        phone: Yup.string().required('Campo obrigatório'),
        justification: Yup.string().trim().required('Campo obrigatório'),
      });
    }
    return RequestSchema;
  };

  validatePhone = (value) => {
    let error;
    value = value.split('_').join('');
    value = value.split(' ').join('');
    value = value.split('-').join('');
    value = value.split('(').join('');
    value = value.split(')').join('');
    if (!value) {
      error = 'É obrigatório preencher seus dados!';
    }
    if (!/[^\d-.\/]/.test(value)) {
      const numbers = value.replace(/[^\d]/g, '');
      if (numbers.length > 0 && numbers.length < 10) {
        error = 'Insira um telefone válido';
      }
    }
    return error;
  };

  handlePhone = (e, handleChange) => {
    const event = e;
    const numbers = event.target.value;
    event.target.value = event.target.value.replace(/[^\d]/g, '');

    const result = phoneMask(numbers);

    event.target.value = result;

    handleChange(event);
  };

  handleName = (e, handleChange) => {
    const event = e;
    event.target.value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
    handleChange(event);
  };

  render() {
    const { close, message, messageTitle, hideJustification } = this.props;
    return (
      <Container>
        <Header className="mb-1">
          <Left>
            {message ? (
              <QuestionClose>
                <Question>{messageTitle}</Question>
                <CloseIcon
                  title="Fechar"
                  className="mdi mdi-close"
                  onClick={close}
                />
              </QuestionClose>
            ) : (
              <>
                <QuestionClose>
                  <Question>Solicitação de manutenção</Question>
                  <CloseIcon
                    title="Fechar"
                    className="mdi mdi-close"
                    onClick={close}
                  />
                </QuestionClose>
              </>
            )}
          </Left>
        </Header>
        <Buttons>
          {message ? <Title style={{ fontSize: 19 }}>{message}</Title> : null}
          <Formik
            initialValues={{
              equipment: '',
              name: '',
              phone: '',
              justification: '',
            }}
            onSubmit={(values, { setSubmitting }) => {
              this.createAssistance(values);
            }}
            validationSchema={this.handleRequestSchema()}
            render={({ handleChange, handleBlur, values, errors, touched }) => (
              <Form
                style={{
                  paddingLeft: '3px',
                  paddingRight: '3px',
                  marginTop: 20,
                }}
              >
                <>
                  <BootstrapForm.Group controlId="name">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <TextField
                            {...field}
                            LeadingIcon={() => <UserIcon />}
                            type="text"
                            label="Informe seu nome *"
                            ariaLabel="Informe seu nome *"
                            ariaRequired
                            errorCondition={errors.name && touched.name}
                            errorMessage={errors.name}
                            title="Informe seu nome *"
                            onBlur={handleBlur}
                            placeholder="Informe seu nome *"
                            value={values.name}
                            onChange={(e) => this.handleName(e, handleChange)}
                          />
                        );
                      }}
                      name="name"
                    />
                  </BootstrapForm.Group>
                  <BootstrapForm.Group className="mb-3" controlId="phone">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <TextField
                            {...field}
                            LeadingIcon={() => <PhoneIcon />}
                            type="tel"
                            label="Seu telefone para contato *"
                            ariaLabel="Seu telefone para contato *"
                            ariaRequired
                            errorCondition={errors.phone && touched.phone}
                            errorMessage={errors.phone}
                            title="Seu telefone para contato *"
                            onBlur={handleBlur}
                            placeholder="Seu telefone para contato *"
                            value={values.phone}
                            onChange={handleChange}
                            maxLength={16}
                            mask="(99) 99999-9999"
                            maskChar=" "
                          />
                        );
                      }}
                      validate={this.validatePhone}
                      name="phone"
                    />
                  </BootstrapForm.Group>
                  {hideJustification ? null : (
                    <BootstrapForm.Group controlId="justification">
                      <FormikField
                        render={({ field }) => {
                          return (
                            <TextArea
                              {...field}
                              LeadingIcon={() => <EditIcon />}
                              type="text"
                              label="Conte-nos o que está acontecendo *"
                              ariaLabel="Conte-nos o que está acontecendo *"
                              ariaRequired
                              errorCondition={
                                errors.justification && touched.justification
                              }
                              errorMessage={errors.justification}
                              title="Conte-nos o que está acontecendo *"
                              onBlur={handleBlur}
                              placeholder="Conte-nos o que está acontecendo *"
                              value={values.justification}
                              onChange={handleChange}
                              required
                            />
                          );
                        }}
                        name="justification"
                      />
                    </BootstrapForm.Group>
                  )}
                </>
                <ButtonContainer>
                  <ButtonWidth>
                    <Button
                      text="Cancelar"
                      outline
                      color={theme.colors.purple}
                      onClick={close}
                    >
                      <ButtonText>Cancelar</ButtonText>
                    </Button>
                  </ButtonWidth>
                  <ButtonWidth>
                    <Button
                      text="Cancelar"
                      color={theme.colors.purple}
                      type="submit"
                    >
                      <ButtonText>Confirmar</ButtonText>
                    </Button>
                  </ButtonWidth>
                </ButtonContainer>
              </Form>
            )}
          />
        </Buttons>
      </Container>
    );
  }
}

export default connect()(Document);
